import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';

import { AuthContext } from '../../context/AuthContext';

import ButtonSecondary from '../../components/ui/ButtonSecondary';
import ButtonPrimary from '../../components/ui/ButtonPrimary';
import BaseTable from '../../components/BaseTable';
import CreateNewDealerModal from './CreateNewDealerModal';
import BaseSearchBar from '../../components/BaseSearchBar';

import {
  fetchDealers,
  addDealerSort,
  fetchDealersBySearchTerm,
  clearDealerSearch
} from '../../store/actions';

import './index.css';
import { sortText } from '../../utils/sortHelper';

const tableOptions = {
  columns: [
    { 
      name: "Dealer",
      dataKey: 'name',
      type: 'text',
      isSortable: true,
    },
    { 
      name: "Auto Make",
      dataKey: 'brand',
      type: 'text',
      isSortable: true,
    },
    { 
      name: "Address",
      dataKey: 'address',
      type: 'text',
      isSortable: true,
    },
    { 
      name: "Phone",
      dataKey: 'phone',
      type: 'text',
      isSortable: true,
    },
    {
      name: "Status",
      dataKey: 'status',
      type: 'select',
      isSortable: true,
      isSelectColored: true,
      selectOptions: [
        {'active': '#219653'},
        {'suspended': '#F2994A'},
        {'deleted': '#EB5757'}
      ],
      isReadOnly: true
    },
    { 
      name: "Counting file",
      type: 'function',
      label: 'Download',
      isSortable: false
    }
  ]
}
  

const Dealers = (props) => {
  const {role} = useContext(AuthContext);
  const initialLocalDealers = props.searchTerm ? props.searchedDealerList : props.dealerList;
  const [localDealers, setLocalDealers] = useState(initialLocalDealers);
  const [isShowCreateNewDealer, setIsShowCreateNewDealer] = useState(false);
  const [searchTerm, setSearchTerm] = useState(props.searchTerm);

  useEffect(() => {
    !props.dealerList.length && props.fetchDealers();
  }, []);

  const choseSort = (column) => {
    if (!column.isSortable) return;
    const { dealerSort } = props;
    props.addDealerSort(column.dataKey, dealerSort.prop === column.dataKey ? !dealerSort.isDesc : true);
  }

  const toggleCreateNewDealer = () => {
    setIsShowCreateNewDealer(!isShowCreateNewDealer);
  }

  const searchDealers = () => {
    props.fetchDealersBySearchTerm(searchTerm);
  }

  const clearDealerSearch = () => {
    setSearchTerm('');
    props.clearDealerSearch();
  }

  const changeSearchTerm = (e) => {
    setSearchTerm(e.target.value);
    !e.target.value && props.clearDealerSearch();
  }

  useEffect(() => {
    const {dealerList, dealerSort, searchedDealerList, searchTerm} = props;
    if (!dealerList.length && !searchedDealerList.length) {
      return setLocalDealers([]);
    }
    const {prop, isDesc} = dealerSort;
    const activeDealerList = searchTerm ? [...searchedDealerList] : [...dealerList];
    const sorted = activeDealerList.sort(sortText(prop, isDesc))
    setLocalDealers(sorted);
  }, [props.dealerList, props.dealerSort, props.searchedDealerList]);

  return (
    <div className="dealers">
      <header className="header">
        <h2 className="header__title">Dealers</h2>
        <BaseSearchBar 
          placeholder="Search by whatever" 
          className="dealers__search-bar"
          value={searchTerm}
          onChange={changeSearchTerm}
          onClear={clearDealerSearch}
          onSearch={searchDealers}
        />
        <ButtonSecondary 
          name="Search"
          onClick={searchDealers}
        />
        {
          role === 'admin' &&
          <ButtonPrimary 
            name="Add New Dealer" 
            onClick={toggleCreateNewDealer}
          />
        }
      </header>
      <div className="table">
        <BaseTable 
          onSort={choseSort} 
          data={localDealers} 
          options={tableOptions} 
          className="dealers__table"
          rowOnClick={(id) => props.history.push(`/dealers/${id}`)}
        />
      </div>
      {
        isShowCreateNewDealer &&
        <CreateNewDealerModal
          onClose={toggleCreateNewDealer}
          selectOptions={{prop: 'dealer', options: props.shortDealerList}}
        />
      }
    </div>  
  );
}

const mapStateToProps = ({
    dealers: 
      { 
        dealerList,
        shortDealerList,
        dealerSort,
        dealerSearch: {
          searchedDealerList,
          searchTerm
        }
      }
  }) => ({ 
    dealerList,
    shortDealerList,
    dealerSort,
    searchedDealerList,
    searchTerm
  });

export default connect(mapStateToProps, { fetchDealers, addDealerSort, fetchDealersBySearchTerm, clearDealerSearch })(Dealers);